import ProjectShowcaseAllProjects from "./modules/ProjectShowcaseAllProjects";
import ProjectShowcaseFeaturedPicture from "./modules/ProjectShowcaseFeaturedPicture";

const projectShowcaseAllProjects = new ProjectShowcaseAllProjects();
const projectShowcaseFeaturedPicture = new ProjectShowcaseFeaturedPicture();
